import { render, staticRenderFns } from "./BemImovel.vue?vue&type=template&id=b0d7fb6c"
import script from "./BemImovel.vue?vue&type=script&lang=js"
export * from "./BemImovel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports